import type { FC } from "react";

import { Column, Text } from "@hightouch/htui";
import { LinkButton, useSearchParams } from "src/router";

import { AuthCard } from "src/components/auth/auth-card";
import { AuthLayout } from "src/components/auth/auth-layout";

// Where the fetcher lands a session the API refuses with SSO_REQUIRED.
export const SsoRequired: FC = () => {
  const [searchParams] = useSearchParams();
  const organizationSlug = searchParams.get("org");

  return (
    <AuthLayout metaTitle="SSO required">
      <AuthCard heading="SSO required" gap={8}>
        <Text>
          This organization requires logging in through SSO. Sign in with your
          identity provider to continue.
        </Text>

        <Column gap={3} width="100%" align="center">
          {/* /sso asks for the organization when the slug didn't reach us. */}
          <LinkButton
            variant="primary"
            href={organizationSlug ? `/sso/${organizationSlug}` : "/sso"}
          >
            Log in with SSO
          </LinkButton>
          {/* AuthLayout hides its own logout once the failing queries clear
              the user, so this screen carries its own. */}
          <LinkButton href={`${import.meta.env.VITE_API_BASE_URL}/auth/logout`}>
            Log out
          </LinkButton>
        </Column>
      </AuthCard>
    </AuthLayout>
  );
};
